(function () {
  var header = document.querySelector('[data-bd-header]');
  if (!header) return;

  /* ---- Mobile nav drawer toggle ---- */
  var navToggle = header.querySelector('[data-bd-nav-toggle]');
  if (navToggle) {
    navToggle.addEventListener('click', function () {
      var isOpen = header.classList.toggle('nav-open');
      navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ---- Mega menu: click/tap toggle (desktop hover is handled purely in CSS) ---- */
  var megaItems = Array.prototype.slice.call(header.querySelectorAll('[data-bd-mega-item]'));

  function closeAllMega(exceptItem) {
    megaItems.forEach(function (item) {
      if (item === exceptItem) return;
      item.classList.remove('is-open');
      var trigger = item.querySelector('[data-bd-mega-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  megaItems.forEach(function (item) {
    var trigger = item.querySelector('[data-bd-mega-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var willOpen = !item.classList.contains('is-open');
      closeAllMega(item);
      item.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  document.addEventListener('click', function (e) {
    megaItems.forEach(function (item) {
      if (!item.contains(e.target)) {
        item.classList.remove('is-open');
        var trigger = item.querySelector('[data-bd-mega-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllMega(null);
      header.classList.remove('nav-open');
      if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---- Wishlist badge ----
     Reads the shared `bd_wishlist` localStorage key. The full add/remove
     logic lives in a future sitewide bd-wishlist.js — this only reflects
     the current count here in the header. */
  function updateWishlistBadge() {
    var badge = header.querySelector('[data-bd-wishlist-badge]');
    if (!badge) return;
    var count = 0;
    try {
      var saved = JSON.parse(localStorage.getItem('bd_wishlist') || '[]');
      count = Array.isArray(saved) ? saved.length : 0;
    } catch (err) {
      count = 0;
    }
    badge.textContent = count;
    badge.hidden = count === 0;
  }
  updateWishlistBadge();
  window.addEventListener('storage', updateWishlistBadge);
  window.addEventListener('bd:wishlist:updated', updateWishlistBadge);

  /* ---- Cart badge ----
     Placeholder hook for when the AJAX add-to-cart is built: dispatch a
     `bd:cart:updated` CustomEvent with { detail: { itemCount: N } } from
     anywhere in the theme and this will keep the badge in sync without a
     full page reload. Until then the badge shows the page-load count. */
  document.addEventListener('bd:cart:updated', function (e) {
    var badge = header.querySelector('[data-bd-cart-badge]');
    if (!badge || !e.detail) return;
    var count = e.detail.itemCount;
    if (typeof count === 'number') {
      badge.textContent = count;
      badge.hidden = count === 0;
    }
  });

  /* ---- Typewriter search placeholder ----
     Cycles through the phrases set in the section's "Animated search
     phrases" setting. Pauses while the field is focused so it never
     fights with what the customer is typing. Skipped entirely for
     prefers-reduced-motion — the static placeholder stays put instead. */
  var searchInput = header.querySelector('[data-bd-search-input]');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (searchInput && !reduceMotion) {
    var phrases = [];
    try {
      phrases = JSON.parse(searchInput.getAttribute('data-bd-search-phrases') || '[]');
    } catch (err) {
      phrases = [];
    }
    phrases = phrases.filter(function (p) { return p && p.trim().length; });

    if (phrases.length > 1) {
      (function typewriter(input, list) {
        var phraseIndex = 0;
        var charIndex = 0;
        var deleting = false;
        var paused = false;
        var timeoutId = null;

        function tick() {
          if (paused) return;
          var current = list[phraseIndex];

          if (!deleting) {
            charIndex++;
            input.setAttribute('placeholder', current.slice(0, charIndex));
            if (charIndex === current.length) {
              deleting = true;
              timeoutId = setTimeout(tick, 1400);
              return;
            }
            timeoutId = setTimeout(tick, 55);
          } else {
            charIndex--;
            input.setAttribute('placeholder', current.slice(0, charIndex));
            if (charIndex === 0) {
              deleting = false;
              phraseIndex = (phraseIndex + 1) % list.length;
              timeoutId = setTimeout(tick, 300);
              return;
            }
            timeoutId = setTimeout(tick, 30);
          }
        }

        input.addEventListener('focus', function () {
          paused = true;
          clearTimeout(timeoutId);
        });
        input.addEventListener('blur', function () {
          if (input.value === '') {
            paused = false;
            clearTimeout(timeoutId);
            tick();
          }
        });

        tick();
      })(searchInput, phrases);
    }
  }

  /* ---- Predictive search ----
     Direct fetch to Shopify's /search/suggest.json (Predictive Search
     API) — no dependency on Dawn's <predictive-search> web component,
     which doesn't fit this custom header DOM.

     Results are ordered BEST MATCH FIRST (see rankProducts) — the product
     whose title is what the customer typed comes on top. They used to be
     sorted A→Z, which pushed the exact product down the list. */
  var searchWrap = header.querySelector('[data-bd-search-wrap]');
  if (searchWrap && searchInput) {
    var resultsBox = searchWrap.querySelector('[data-bd-search-results]');
    var debounceId = null;
    var activeIndex = -1;
    var currentItems = [];

    /* works on translated / sub-folder stores too (e.g. /en/) */
    var routesRoot =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function closeResults() {
      resultsBox.hidden = true;
      resultsBox.innerHTML = '';
      activeIndex = -1;
      currentItems = [];
    }

    function formatPrice(amount) {
      var num = parseFloat(amount);
      if (isNaN(num)) return '';
      return '₹' + num.toLocaleString('en-IN', { maximumFractionDigits: 0 });
    }

    /* Lower score = shown higher.
         0  title is exactly what was typed
         1  title STARTS with what was typed
         2  title contains the whole phrase
         3  title contains ALL typed words (any order)
         4  title contains SOME typed words
         5  matched through tags / description only
       Sold-out products always go below in-stock ones.
       Ties keep Shopify's own relevance order. */
    function rankProducts(products, query) {
      var q = (query || '').trim().toLowerCase();
      var words = q.split(/\s+/).filter(Boolean);

      return products
        .map(function (product, index) {
          var title = (product.title || '').toLowerCase();
          var score = 5;

          if (title === q) {
            score = 0;
          } else if (title.indexOf(q) === 0) {
            score = 1;
          } else if (title.indexOf(q) > -1) {
            score = 2;
          } else {
            var hits = words.filter(function (w) { return title.indexOf(w) > -1; }).length;
            if (words.length && hits === words.length) score = 3;
            else if (hits > 0) score = 4;
          }

          if (product.available === false) score += 10;

          return { product: product, index: index, score: score };
        })
        .sort(function (a, b) {
          return a.score - b.score || a.index - b.index;
        })
        .map(function (item) {
          return item.product;
        });
    }

    /* ONLY products whose TITLE contains every word the customer typed.
       Shopify's suggest API also returns fuzzy / tag / description / vendor
       matches — those are dropped here so the list shows just the product
       that was typed. (Half-typed words still work: "minim" is found in
       "Minimal".) */
    function matchesTyped(product, query) {
      var title = (product.title || '').toLowerCase();
      var words = (query || '').trim().toLowerCase().split(/\s+/).filter(Boolean);

      if (!words.length) return false;

      return words.every(function (word) {
        return title.indexOf(word) > -1;
      });
    }

    function renderResults(products, term) {
      var safeTerm = escapeHtml(term);

      products = products.filter(function (product) {
        return matchesTyped(product, term);
      });

      if (!products.length) {
        resultsBox.innerHTML = '<div class="bd-search-results__empty">No products found for “' + safeTerm + '”</div>';
        resultsBox.hidden = false;
        currentItems = [];
        return;
      }

      products = rankProducts(products, term);
      currentItems = products;
      activeIndex = -1;

      var itemsHtml = products.map(function (p) {
        var priceHtml = formatPrice(p.price);
        var comparePrice = p.compare_at_price_max || p.compare_at_price;
        if (comparePrice && parseFloat(comparePrice) > parseFloat(p.price_max || p.price)) {
          priceHtml = '<s>' + formatPrice(comparePrice) + '</s> ' + priceHtml;
        }
        var img = p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy">' : '';
        return (
          '<a href="' + escapeHtml(p.url) + '" class="bd-search-results__item">' +
            '<span class="bd-search-results__thumb">' + img + '</span>' +
            '<span class="bd-search-results__info">' +
              '<span class="bd-search-results__title">' + escapeHtml(p.title) + '</span>' +
              '<span class="bd-search-results__price">' + priceHtml + '</span>' +
            '</span>' +
          '</a>'
        );
      }).join('');

      /* options[prefix]=last lets the full results page match half-typed
         words too ("minim" -> "Minimal ..."); options[fields]=title makes
         it look at product TITLES only, same as the dropdown */
      var viewAllHtml =
        '<a href="' + routesRoot + 'search?q=' + encodeURIComponent(term) +
        '&options%5Bprefix%5D=last&options%5Bfields%5D=title&type=product" class="bd-search-results__viewall">View all results for “' + safeTerm + '”</a>';

      resultsBox.innerHTML = itemsHtml + viewAllHtml;
      resultsBox.hidden = false;
    }

    function fetchResults(term) {
      fetch(
        routesRoot + 'search/suggest.json?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title'
      )
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (term !== searchInput.value.trim()) return; // stale response — a newer keystroke has already fired
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products, term);
        })
        .catch(function () {
          resultsBox.innerHTML = '<div class="bd-search-results__empty">Something went wrong. Please try again.</div>';
          resultsBox.hidden = false;
        });
    }

    searchInput.addEventListener('input', function () {
      var term = searchInput.value.trim();
      clearTimeout(debounceId);
      if (term.length < 2) {
        closeResults();
        return;
      }
      resultsBox.innerHTML = '<div class="bd-search-results__loading">Searching…</div>';
      resultsBox.hidden = false;
      debounceId = setTimeout(function () { fetchResults(term); }, 300);
    });

    /* coming back to the box with text already typed: show the list again */
    searchInput.addEventListener('focus', function () {
      var term = searchInput.value.trim();
      if (term.length >= 2 && resultsBox.hidden) {
        fetchResults(term);
      }
    });

    searchInput.addEventListener('keydown', function (e) {
      if (!currentItems.length || resultsBox.hidden) return;
      var links = resultsBox.querySelectorAll('.bd-search-results__item');
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, links.length - 1);
        links.forEach(function (el, i) { el.classList.toggle('is-active', i === activeIndex); });
        links[activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
        links.forEach(function (el, i) { el.classList.toggle('is-active', i === activeIndex); });
        links[activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        if (activeIndex >= 0 && links[activeIndex]) {
          e.preventDefault();
          window.location.href = links[activeIndex].getAttribute('href');
        }
      } else if (e.key === 'Escape') {
        closeResults();
        searchInput.blur();
      }
    });

    document.addEventListener('click', function (e) {
      if (!searchWrap.contains(e.target)) closeResults();
    });
  }
})();